import { render, staticRenderFns } from "./WorkingoutExerciseAddSetNew.vue?vue&type=template&id=327a5492&scoped=true&xmlns=true"
import script from "./WorkingoutExerciseAddSetNew.vue?vue&type=script&lang=js"
export * from "./WorkingoutExerciseAddSetNew.vue?vue&type=script&lang=js"
import style0 from "./WorkingoutExerciseAddSetNew.vue?vue&type=style&index=0&id=327a5492&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327a5492",
  null
  
)

export default component.exports